import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  PageHeading,
  SubHeading,
  SubsectionHeading,
} from 'web-ui-components/lib/typography/headings';
import {
  PAGE_CALL_PAYMENT,
  PAGE_CONTACT_SELLER,
} from '../../../constants/FraudAndDisputeConstants';
import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';

import { FieldLabel } from 'web-ui-components/lib/typography/labels';

import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { PaymentDetailComponent } from './PaymentDetailComponent';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import { CHATBOT_LETS_CHAT_LINK_ID } from '../../../constants/ChatbotConstants';

class HelpWithThisPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false || props.openDisputePaymentModal,
    };
  }

  closeModal = () => this.setState({ isOpen: false });
  openModal = () => this.setState({ isOpen: true });

  render() {
    const { content, setPage, data, logoInitials, closeDisputePaymentModal } =
      this.props;

    const modalContent = (
      <div>
        <SubHeading>{content.helpWithPaymentDisputeModalTitle}</SubHeading>
        <FieldLabel htmlFor="weWillInvestigate">
          {content.weWillInvestigateText}
        </FieldLabel>
        <StandardBody>
          <BulletList items={content.weWillInvestigateBulletlist} />
          <FieldLabel htmlFor="beforeYouStart">
            {content.beforeYouStart}
          </FieldLabel>
          <BulletList items={content.beforeYouStartBulletlist} />
          <FieldLabel htmlFor="jointAccounts">
            {content.jointAccountsSubHeader}
          </FieldLabel>
          <p>{content.jointAccountSubText}</p>
          <FieldLabel htmlFor="disputingMultiplePayments">
            {content.disputingMultiplePayments}
          </FieldLabel>
          <p>{content.youCanDisputeMultiplePaymentText}</p>
        </StandardBody>
      </div>
    );
    return (
      <div className="bow help-with-payment-page">
        <div className="col-xs-8">
          <PageHeading>{content.helpWithPaymentTitle}</PageHeading>
        </div>
        <Grid.ThreeToOne>
          <PaymentDetailComponent data={data} logoInitials={logoInitials} />
        </Grid.ThreeToOne>
        <div className="help-with-payment-container">
          <div className="help-with-payment-component">
            <div className="help-with-payment-component-heading">
              <SubsectionHeading>
                <img
                  alt="warning"
                  src="../../../../images/bow/statement.svg"
                ></img>
                <span className="text-center heading-content">
                  {content.helpWithPaymentDisputeTitle}
                </span>
              </SubsectionHeading>
            </div>
            <p className="help-with-payment-component-content">
              <strong>{content.helpWithPaymentDisputeText}</strong>
            </p>
            <div className="help-with-payment-component-button">
              <NavigationButton.Secondary
                data-test-id="dispute-payment-button"
                labelText="Dispute payment"
                onClick={() => {
                  AnalyticsUtil.analyticAction(
                    config.analytics.analytics_experience_activity,
                    config.analytics.analytics_event_method_interacted,
                    config.analytics.analytics_action_dispute_payment,
                    config.analytics.analytics_action_button_click
                  );
                  FraudAndDisputeActionCreator.resetRefundDetails();
                  FraudAndDisputeStore.getDisputeJourneyType() &&
                    FraudAndDisputeActionCreator.clearDisputeFormData();
                  this.openModal();
                }}
              />
            </div>
          </div>
          <div className="help-with-payment-component">
            <div className="help-with-payment-component-heading">
              <SubsectionHeading>
                <img alt="warning" src="../../../../images/bow/chat.svg"></img>
                <span className="text-center heading-content">
                  {content.helpWithPaymentSomethingElseTitle}
                </span>
              </SubsectionHeading>
            </div>
            <p className="help-with-payment-component-content">
              <strong> {content.helpWithPaymentSomethingElseText}</strong>
            </p>
            <div className="help-with-payment-component-chat-button">
              <NavigationButton.Secondary
                data-test-id="report-fraud-button"
                labelText="Start chat"
                onClick={() => {
                  /**
                   * Unfortunately, current Chatbot implementation is doing
                   * explicit script inject, hence lack of action creators,
                   * or simple open/close handlers.
                   */
                  document.getElementById(CHATBOT_LETS_CHAT_LINK_ID)?.click();
                }}
              />
            </div>
          </div>
        </div>
        <PatternLibModalComponent
          isOpen={this.state.isOpen}
          onHide={this.closeModal}
          show={this.state.isOpen}
          customClass={'c-modal dispute-modal'}
          modalBody={modalContent}
          modalFooter={
            <div className="text-center">
              <NavigationButton.Primary
                labelText={content.disputeThisPayment}
                onClick={() => {
                  AnalyticsUtil.analyticAction(
                    config.analytics.analytics_experience_activity,
                    config.analytics.analytics_event_method_interacted,
                    config.analytics.analytics_action_dispute_payment_modal,
                    config.analytics.analytics_action_button_click
                  );
                  setPage(PAGE_CONTACT_SELLER);
                  closeDisputePaymentModal();
                }}
              />
              <NavigationButton.Secondary
                labelText={content.disputeMultiplePayments}
                onClick={() => {
                  AnalyticsUtil.analyticAction(
                    config.analytics.analytics_experience_activity,
                    config.analytics.analytics_event_method_interacted,
                    config.analytics
                      .analytics_action_dispute_multiple_payments_modal,
                    config.analytics.analytics_action_button_click
                  );
                  setPage(PAGE_CALL_PAYMENT);
                }}
              />
            </div>
          }
        />
      </div>
    );
  }
}

HelpWithThisPayment.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
  data: PropTypes.object,
  logoInitials: PropTypes.string,
  closeDisputePaymentModal: PropTypes.func,
};
export default HelpWithThisPayment;
